import * as React from 'react';
import { LucideIcon } from 'lucide-react';

interface IconProps extends React.HTMLAttributes<HTMLElement> {
  icon: LucideIcon | any;
  size?: number;
  className?: string;
}

export function Icon({ icon: IconComponent, size = 24, className = '', ...props }: IconProps) {
  return <IconComponent size={size} className={className} {...props} />;
}
